import PropTypes from 'prop-types';
// form
import { Controller, useFormContext } from 'react-hook-form';
import { Grid, Slider, TextField } from '@mui/material';
// @mui

// ----------------------------------------------------------------------

export default function RHFSlider({ name, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Grid container spacing={2} alignItems="center">
          <Grid item xs>
            <Slider {...field} {...other} />
          </Grid>
          <Grid item>
            <TextField
              {...field}
              size="small"
              inputProps={{
                step: 1,
                min: other?.min || 0,
                max: other?.max || 100,
                type: 'number',
                'aria-labelledby': `${name}-slider`,
              }}
              sx={{ width: 80 }}
            />
          </Grid>
        </Grid>
      )}
    />
  );
}

RHFSlider.propTypes = {
  name: PropTypes.string,
};
